<template>
  <div class="inline-block released-po-container">
    <div class="row released-po">
      <label
        class="small-6 released-po__select"
      >
        {{ $t('project.submission.releasedPo') }}
      </label>
      <label
        class="small-6"
      >
        {{ $t('project.submission.glDate') }}
      </label>
    </div>
    <div class="row">
      <div
        class="small-6 released-po__select"
        :class="{ 'readonly': !isOpen }"
      >
        <template v-if="isOpen && isPic">
          <HKLSelect
            v-model="releasedPo"
            :options="releasedPoOpts"
          />
          <p
            v-if="showErrHint"
            class="text_red"
          >
            {{ $t('hint.noAvailableReleasedPo') }}
          </p>
        </template>
        <p v-else>
          <template v-if="isAccepted">
            {{ releasedPo | isEmptyValue }}
          </template>
          <template v-else>
            {{ $t('emptyValue') }}
          </template>
        </p>
      </div>
      <div
        class="small-6 released-po__date"
        :class="{ 'readonly': !isOpen }"
      >
        <p>
          <template v-if="isAccepted || isPic">
            {{ displayGlDate | isEmptyValue }}
          </template>
          <template v-else>
            {{ $t('emptyValue') }}
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { computed, onMounted, unref, toRefs } from 'vue-demi'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import { useStoreActions, useStoreGetters } from '@/store/index'
import { aclHelper } from '@/utils/aclHelper'
import dateUtil from '@/utils/dateUtil'
import { updateSubmission } from '@/api/projects/request'
import { useRouteParamId } from '@/router/useRouter'
import { PROJECT_TYPES } from '../consts'
import { useReleasedPos, useSubmissionStatus } from './hook'

export default {
  components: {
    HKLSelect,
  },
  props: {
    submission: {
      type: Object,
      default: () => ({}),
    },
  },

  setup (props, { emit }) {
    const { submission: refSubmission } = toRefs(props)
    const isPic = computed(() => {
      return aclHelper.isProjectPic()
    })
    const { parsedReleasedPos, validReleasedPos, refresh: getReleasedPos } = useReleasedPos()
    const { currentProject } = useStoreGetters('projects', ['currentProject'])
    const isContract = computed(() => {
      const numberType = lodash.get(currentProject, 'value.numberType')
      return numberType === PROJECT_TYPES.CONTRACT
    })
    const submissionStatus = useSubmissionStatus(refSubmission, false)
    const { isOpen, isAccepted } = submissionStatus
    const releasedPoOpts = computed(() => {
      return unref(validReleasedPos).map(item => {
        const formatDate = dateUtil.formatByLongDate(item.glDate, 'L')
        return { name: `${item.releasedPoNum} - ${formatDate}`, value: item.releasedPoNum }
      })
    })
    const selectedPo = {
      releasedPo: computed({
        get: () => lodash.get(unref(refSubmission), 'releasedPo', ''),
        set: (value) => {
          emitSelectedAndSaved(value)
        },
      }),
      glDate: computed(() => lodash.get(unref(refSubmission), 'glDate') || null),
      displayGlDate: computed(() => {
        return dateUtil.formatByLongDate(unref(selectedPo.glDate), 'L')
      }),
    }
    const showErrHint = computed(() => {
      return !unref(validReleasedPos).length && !unref(selectedPo.releasedPo)
    })
    const { loadProject } = useStoreActions('projects', ['loadProject'])
    const projectId = useRouteParamId()
    const emitSelectedAndSaved = async (releasedPo) => {
      const selectedOpt = unref(parsedReleasedPos).find(item => item.releasedPoNum === releasedPo)
      const glDate = lodash.get(selectedOpt, 'glDate', null)
      emit('update:selectedReleasedPo', releasedPo)
      const reqSubmission = {
        id: unref(refSubmission).id,
        releasedPo,
        glDate: glDate,
      }
      await updateSubmission(reqSubmission, false)
      await loadProject(unref(projectId))
    }
    onMounted(async () => {
      const shouldGetOpts = unref(isContract) && unref(isOpen)
      if (shouldGetOpts) {
        await getReleasedPos()
      }
    })
    return {
      showErrHint,
      isAccepted,
      isPic,
      ...submissionStatus,
      isContract,
      parsedReleasedPos,
      releasedPoOpts,
      ...selectedPo,
    }
  },
}
</script>

<style lang="scss" scoped>
.inline-block {
  display: inline-block;
  vertical-align: top;
}
.released-po-container {
  width: 40%;
}
.released-po {
  &__select {
    padding-right: 10px;
    &.readonly {
      line-height: initial;
    }
  }
  &__date {
    p {
      line-height: 40px;
    }
    &.readonly p {
      line-height: initial;
    }
  }
}
</style>
